import { useEffect, useRef, useState } from "react";

import GuestImg from "../../assets/images/conversations/ep-04-sulajja-firodia-guest.webp";
import ThumbImg from "../../assets/images/conversations/004.webp";
import PlayIcon  from "../../assets/icons/conversations/play-icon.svg";
import FacebookIcon from "../../assets/icons/conversations/facebook.svg";
import LinkedinIcon from "../../assets/icons/conversations/linkedin.svg";
import TwitterIcon  from "../../assets/icons/conversations/twitter.svg";

/* ─────────────────────────────────────────────
   PREFIX: sf-
───────────────────────────────────────────── */
const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700;800&family=Roboto:wght@400;500&display=swap');

  *, *::before, *::after { margin: 0; padding: 0; box-sizing: border-box; }

  .sf-page {
    background: #1A1A1A;
    min-height: 100vh;
    font-family: 'Roboto', sans-serif;
    color: #fff;
  }
  .sf-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding-left: 102px;
    padding-right: 102px;
  }

  .sf-hero { padding-top: 60px; padding-bottom: 60px; }
  .sf-hero__grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 30px;
    align-items: start;
  }
  .sf-hero__left { display: flex; flex-direction: column; gap: 34px; }
  .sf-hero__title {
    font-family: 'Montserrat', sans-serif;
    font-size: 32px;
    font-weight: 700;
    color: #ffffff;
    line-height: 140%;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .sf-hero__title.sf-visible { opacity: 1; transform: translateY(0); }

  /* social share buttons */
  .sf-hero__social {
    display: flex;
    gap: 14px;
    flex-wrap: wrap;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.08s, transform 0.7s ease 0.08s;
  }
  .sf-hero__social.sf-visible { opacity: 1; transform: translateY(0); }
  .sf-hero__social a {
    display: inline-flex;
    align-items: center;
    gap: 14px;
    padding: 10px 14px;
    font-family: 'Roboto', sans-serif;
    font-size: 16px;
    font-weight: 500;
    color: #ffffff;
    text-decoration: none;
    transition: opacity 0.2s ease;
  }
  .sf-hero__social a:hover { opacity: 0.85; }
  .sf-hero__social a.fb { background: #3B5998; }
  .sf-hero__social a.li { background: #0077B5; }
  .sf-hero__social a.tw { background: #1DA1F2; }
  .sf-hero__social a img { width: 18px; height: 18px; flex-shrink: 0; }

  .sf-hero__spotify {
    border-radius: 12px;
    overflow: hidden;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.18s, transform 0.7s ease 0.18s;
  }
  .sf-hero__spotify.sf-visible { opacity: 1; transform: translateY(0); }
  .sf-hero__spotify iframe {
    display: block; width: 100%; height: 152px; border: none; border-radius: 12px;
  }
  .sf-hero__right {
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.1s, transform 0.7s ease 0.1s;
  }
  .sf-hero__right.sf-visible { opacity: 1; transform: translateY(0); }

  .sf-yt-thumb {
    position: relative; width: 100%; border-radius: 12px;
    overflow: hidden; cursor: pointer; display: block; background: #000;
  }
  .sf-yt-thumb img {
    width: 100%; height: auto; display: block;
    border-radius: 12px; transition: opacity 0.3s ease;
  }
  .sf-yt-thumb:hover img { opacity: 0.85; }
  .sf-yt-thumb__play {
    position: absolute; top: 50%; left: 50%;
    transform: translate(-50%, -50%);
    background: none; border-radius: 50%;
    display: flex; align-items: center; justify-content: center;
    pointer-events: none;
  }
  .sf-yt-thumb__play img { width: 40px; height: 44px; }
  .sf-yt-iframe-wrap {
    position: relative; width: 100%; padding-bottom: 56.25%;
    height: 0; border-radius: 12px; overflow: hidden;
  }
  .sf-yt-iframe-wrap iframe {
    position: absolute; top: 0; left: 0;
    width: 100%; height: 100%; border: none;
  }

  .sf-body {
    padding-bottom: 100px; opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .sf-body.sf-visible { opacity: 1; transform: translateY(0); }
  .sf-body__label {
    font-family: 'Roboto', sans-serif; font-size: 16px;
    font-weight: 400; color: #E2E2E2; line-height: 160%; margin-bottom: 14px;
  }
  .sf-body__para {
    font-family: 'Roboto', sans-serif; font-size: 16px;
    font-weight: 400; color: #E2E2E2; line-height: 160%; margin-bottom: 14px;
  }
  .sf-body__para:last-child { margin-bottom: 0; }

  .sf-guest {
    padding-bottom: 100px; text-align: center; opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .sf-guest.sf-visible { opacity: 1; transform: translateY(0); }
  .sf-guest__title {
    font-family: 'Montserrat', sans-serif; font-size: 50px;
    font-weight: 700; color: #ffffff; margin-bottom: 60px;
  }
  .sf-guest__photo-bg {
    display: inline-block; width: 445px; height: 500px;
    background: #743FAC; border-radius: 12px; overflow: hidden;
  }
  .sf-guest__photo-bg img {
    width: 100%; height: 100%; object-fit: cover;
    object-position: top center; display: block;
  }
  .sf-guest__name {
    font-family: 'Montserrat', sans-serif; font-size: 32px;
    font-weight: 700; color: #ffffff; margin-top: 24px;
  }

  /* ── TABLET (max 768px) ── */
  @media (max-width: 768px) {
    .sf-inner { padding-left: 32px; padding-right: 32px; }
    .sf-hero { padding-top: 32px; padding-bottom: 48px; }
    .sf-hero__grid { grid-template-columns: 1fr 1fr; gap: 24px; }
    .sf-hero__title { font-size: 24px; }
    .sf-hero__left { gap: 16px; }
    .sf-hero__social { gap: 10px; }
    .sf-hero__social a { gap: 10px; font-size: 12px; padding: 10px 12px; }
    .sf-guest__title { font-size: 24px; margin-bottom: 24px; }
    .sf-guest__photo-bg { width: 260px; height: 300px; }
    .sf-guest__name { font-size: 24px; margin-top: 18px; }
    .sf-body__para { font-size: 14px; margin-bottom: 12px; }
    .sf-body__label { font-size: 14px; margin-bottom: 12px; }
    .sf-body { padding-bottom: 48px; }
    .sf-guest { padding-bottom: 48px; }
    .sf-yt-thumb__play img { width: 30px; height: 32px; }
  }

  /* ── MOBILE (max 480px) ── */
  @media (max-width: 480px) {
    .sf-inner { padding-left: 16px; padding-right: 16px; }
    .sf-hero { padding-top: 51px; padding-bottom: 30px; }
    .sf-hero__grid { grid-template-columns: 1fr; gap: 30px; }
    .sf-hero__left { gap: 30px; }
    .sf-hero__title { font-size: 30px; }
    .sf-hero__social { gap: 11px; }
    .sf-hero__social a { gap: 10px; font-size: 15px; padding: 10px 14px; }
    .sf-body__para { font-size: 16px; margin-bottom: 10px; }
    .sf-body__label { font-size: 16px; margin-bottom: 10px; }
    .sf-guest__title { font-size: 30px; margin-bottom: 20px; }
    .sf-guest__photo-bg { width: 100%; height: 386px; }
    .sf-guest__name { font-size: 24px; text-align: left; margin-top: 14px; }
    .sf-body { padding-bottom: 30px; }
    .sf-guest { padding-bottom: 30px; }
    .sf-yt-thumb__play img { width: 30px; height: 32px; }
  }
`;

function useFadeUp(ref) {
  useEffect(() => {
    if (!ref.current) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("sf-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);
}

const YT_VIDEO_ID = "REPLACE_EP04_VIDEO_ID";

function YouTubeEmbed() {
  const [playing, setPlaying] = useState(false);
  if (playing) {
    return (
      <div className="sf-yt-iframe-wrap">
        <iframe
          src={`https://www.youtube.com/embed/${YT_VIDEO_ID}?autoplay=1&rel=0`}
          title="EP 04 Sulajja Firodia Motwani"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    );
  }
  return (
    <div className="sf-yt-thumb" onClick={() => setPlaying(true)} role="button" aria-label="Play video">
      <img src={ThumbImg} alt="EP 04 Sulajja Firodia Motwani thumbnail" />
      <div className="sf-yt-thumb__play">
        <img src={PlayIcon} alt="Play" />
      </div>
    </div>
  );
}

function HeroSection() {
  const titleRef   = useRef(null);
  const socialRef  = useRef(null);
  const spotifyRef = useRef(null);
  const rightRef   = useRef(null);
  useFadeUp(titleRef);
  useFadeUp(socialRef);
  useFadeUp(spotifyRef);
  useFadeUp(rightRef);

  return (
    <section className="sf-hero">
      <div className="sf-inner">
        <div className="sf-hero__grid">
          <div className="sf-hero__left">
            <div ref={titleRef} className="sf-hero__title">
              EP 04 | Candid conversation with Sulajja FIRODIA MOTWANI, Founder &amp; CEO at Kinetic Green Energy on achieving the electric dream in India
            </div>
            <div ref={socialRef} className="sf-hero__social">
              <a href="https://www.facebook.com/sharer/sharer.php?u=" className="fb" target="_blank" rel="noreferrer">
                <img src={FacebookIcon} alt="Facebook" /> Facebook
              </a>
              <a href="https://www.linkedin.com/sharing/share-offsite/?url=" className="li" target="_blank" rel="noreferrer">
                <img src={LinkedinIcon} alt="LinkedIn" /> Linked in
              </a>
              <a href="https://twitter.com/intent/tweet?url=" className="tw" target="_blank" rel="noreferrer">
                <img src={TwitterIcon} alt="Twitter" /> Twitter
              </a>
            </div>
            <div ref={spotifyRef} className="sf-hero__spotify">
              <iframe
                src="https://open.spotify.com/embed/episode/1kpVrruaFo9qPfwak9pDex?utm_source=generator&theme=0"
                allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                loading="lazy"
                title="EP 04 Spotify Player"
              />
            </div>
          </div>
          <div ref={rightRef} className="sf-hero__right">
            <YouTubeEmbed />
          </div>
        </div>
      </div>
    </section>
  );
}

function BodySection() {
  const ref = useRef(null);
  useFadeUp(ref);
  return (
    <section ref={ref} className="sf-body">
      <div className="sf-inner">
        <p className="sf-body__label">Episode Summary</p>
        <p className="sf-body__para">
          In today's episode of Energizing India Podcast, we feature India's most iconic brand.
        </p>
        <p className="sf-body__para">
          Sulajja FIRODIA Founder &amp; CEO at Kinetic Green Energy is a pioneer of electric vehicles in India, staying true to her family heritage that pioneered the iconic LUNA in the 60s and India's first gearless scooter, the Kinetic Honda in the 80s. Sulajja is one of India's well-recognized women entrepreneurs presently working to change the passenger transit and light goods transport segment and how this important aspect of mobility in India is being decarbonized through innovative electric solutions.
        </p>
        <p className="sf-body__para">
          Listen in to hear the journey of Sulajja from her days at Carnegie Mellon to today leading the electric revolution in light goods transport and what is her dream for Kinetic Green.
        </p>
      </div>
    </section>
  );
}

function GuestSection() {
  const ref = useRef(null);
  useFadeUp(ref);
  return (
    <section ref={ref} className="sf-guest">
      <div className="sf-inner">
        <h2 className="sf-guest__title">Our Guest</h2>
        <div>
          <div className="sf-guest__photo-bg">
            <img src={GuestImg} alt="Sulajja Firodia Motwani" />
          </div>
          <p className="sf-guest__name">Sulajja FIRODIA MOTWANI</p>
        </div>
      </div>
    </section>
  );
}

export default function Ep04SulajjaFirodia() {
  return (
    <>
      <style>{CSS}</style>
      <div className="sf-page">
        <HeroSection />
        <BodySection />
        <GuestSection />
      </div>
    </>
  );
}